import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack } from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL


const PublicEventCard = ({ event, user }) => {
	const navigate = useNavigate();

	return (
		<>
			{
				event !== undefined ? 
				<>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						className="bg-[#a3c9ff] py-3 pl-4 pr-6 rounded-2xl mt-1">
						<Box>
							<h4 className="text-white">{event.Name}</h4>
							<p className="text-black">{event.Date}</p>
						</Box>
						<button 
							style={{ marginLeft: "auto"}}
							onClick={()=> {navigate(`/Events/${event.UID}`)}}
							className="bg-[#0060AB] px-4 rounded-[40px] h-10 tracking-widest  text-black font-medium"
						>
							Open
						</button>
					</Stack>
				</> : <></>
			}
		</>
	)
}

export default PublicEventCard;